import { useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { filterFalsy } from 'dibs-ts-utils/exports/filterFalsy.ts';

import { type useAppliedFilterUrlLabel_itemSearch$key } from './__generated__/useAppliedFilterUrlLabel_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment useAppliedFilterUrlLabel_itemSearch on ItemSearchQueryConnection {
        appliedFilters {
            name
            values {
                urlLabel
            }
        }
    }
`;

export const useAppliedFilterUrlLabels = (
    itemSearchRef: useAppliedFilterUrlLabel_itemSearch$key,
    filterName: string | null | undefined
): string[] => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { appliedFilters } = itemSearch;
    const urlLabels = useMemo(
        () =>
            filterName
                ? appliedFilters
                      ?.find(filter => filter?.name === filterName)
                      ?.values?.map(value => value?.urlLabel)
                      ?.filter(filterFalsy) || []
                : [],
        [appliedFilters, filterName]
    );
    return urlLabels;
};

export const useAppliedFilterUrlLabel = (
    itemSearchRef: useAppliedFilterUrlLabel_itemSearch$key,
    filterName: string | null | undefined
): string | null => {
    const urlLabels = useAppliedFilterUrlLabels(itemSearchRef, filterName);
    return urlLabels[0] || null;
};
